export default "__VITE_ASSET__BWdPYln6__"